import React from 'react'
import { StatCardProps } from './StatCard.types'
import { Container, Icon, Value, Label } from './StatCard.styles'

export const StatCard: React.FC<StatCardProps> = ({
  value,
  label,
  variant = 'default',
  highlight = false,
  icon,
  disabled = false,
  clickable = false,
  className,
  style,
  onClick,
  title,
}) => {
  const handleClick = () => {
    if (!disabled && clickable && onClick) {
      onClick()
    }
  }

  return (
    <Container
      $variant={variant}
      $highlight={highlight}
      $hasIcon={!!icon}
      $disabled={disabled}
      $clickable={clickable}
      onClick={handleClick}
      className={className}
      style={style}
      title={
        title || (disabled ? 'This stat is currently unavailable' : undefined)
      }
    >
      {icon && <Icon $variant={variant}>{icon as any}</Icon>}
      <Value $variant={variant}>{value}</Value>
      <Label>{label}</Label>
    </Container>
  )
}

StatCard.displayName = 'StatCard'
